export default function EmbedForm({embedCode}) {
  return (
    <div
      className="flex justify-start md:justify-center"
      style={{ marginTop: "30px", marginBottom: "60px" }}
    >
      <div dangerouslySetInnerHTML={{ __html: embedCode }} />
    </div>
  );
}
